import _ from 'underscore';
import checkbox from '@bingads-webui-component-legacy/form/viewmodel/control/checkbox';
import radios from '@bingads-webui-component-legacy/form/viewmodel/control/radios';
import select from '@bingads-webui-component-legacy/form/viewmodel/control/select';
import text from '@bingads-webui-component-legacy/form/viewmodel/control/text';
import textarea from '@bingads-webui-component-legacy/form/viewmodel/control/textarea';
import staticDiv from '@bingads-webui-component-legacy/form/viewmodel/control/static';
import label from '@bingads-webui-component-legacy/form/viewmodel/control/label';
import visible from '@bingads-webui-component-legacy/form/viewmodel/control/visible';
import collapse from '@bingads-webui-component-legacy/form/viewmodel/control/collapse';

const specified = {
  checkbox,
  radios,
  'inline-radios': radios,
  select,
  text,
  textarea,
  collapse,
  static: staticDiv,
};

export default function(control, local, attrs, custom, viewModel) {
  if (custom.hasSubFields !== true) {
    label(local, attrs, custom, viewModel);
    visible(local, attrs, custom, viewModel);
  }

  if (_.isFunction(specified[control])) {
    specified[control](local, attrs, custom, viewModel);
  }
}
